import React, { useState } from "react";

// Temporary Link wrapper (use react-router-dom later)
const Link = ({ to, children, className, onClick }) => (
  <a href={to} className={className} onClick={onClick}>
    {children}
  </a>
);

// Icons
const MenuIcon = (props) => (
  <svg
    {...props}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <line x1="4" y1="6" x2="20" y2="6" />
    <line x1="4" y1="12" x2="20" y2="12" />
    <line x1="4" y1="18" x2="20" y2="18" />
  </svg>
);

const CloseIcon = (props) => (
  <svg
    {...props}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <line x1="6" y1="6" x2="18" y2="18" />
    <line x1="18" y1="6" x2="6" y2="18" />
  </svg>
);

// -------------------------------------------------------------
//                     MAIN NAVBAR
// -------------------------------------------------------------

export default function Navbar() {
  const [isOpen, setIsOpen] = useState(false);
  const [roleModal, setRoleModal] = useState(false);

  const toggleMenu = () => setIsOpen((prev) => !prev);

  const commonBtn =
    "py-1.5 px-4 rounded-md text-sm font-medium tracking-wide transition-all duration-150";
  const loginBtn =
    commonBtn +
    " border border-gray-700 text-gray-800 hover:bg-gray-100";
  const primaryBtn =
    commonBtn +
    " bg-gray-900 text-white hover:bg-black shadow-sm";

  return (
    <>
      <nav
        className="w-full fixed top-0 left-0 z-50 bg-white border-b border-gray-200 shadow-sm"
        style={{ fontFamily: "Poppins, Roboto, sans-serif" }}
      >
        <div className="max-w-7xl mx-auto px-4 sm:px-6 py-3 flex items-center justify-between">
          {/* Mobile menu button */}
          <button
            onClick={toggleMenu}
            className="md:hidden text-gray-800 p-2 rounded-md hover:bg-gray-100 transition"
          >
            {isOpen ? (
              <CloseIcon className="h-6 w-6" />
            ) : (
              <MenuIcon className="h-6 w-6" />
            )}
          </button>

          {/* LOGO */}
          <Link
            to="/"
            className="text-xl font-semibold text-gray-900 absolute md:relative left-1/2 md:left-0 transform md:transform-none -translate-x-1/2"
          >
            GTPL HRMS
          </Link>

          {/* Desktop buttons */}
          <div className="hidden md:flex items-center space-x-4">
            <button
              className={loginBtn}
              onClick={() => setRoleModal(true)}
            >
              Login
            </button>
            {/* <Link to="/register" className={primaryBtn}>
              Register
            </Link> */}
          </div>

          {/* Spacer for alignment */}
          <div className="md:hidden w-8" />
        </div>

        {/* Mobile dropdown */}
        <div
          className={`md:hidden overflow-hidden transition-all duration-300 ${
            isOpen ? "max-h-52 py-3 border-t border-gray-200" : "max-h-0"
          }`}
        >
          <div className="flex flex-col space-y-3 px-4 sm:px-6">
            <button
              onClick={() => {
                setIsOpen(false);
                setRoleModal(true);
              }}
              className={loginBtn + " w-full text-center"}
            >
              Login
            </button>

            {/* <Link
              to="/register"
              className={primaryBtn + " w-full text-center"}
              onClick={() => setIsOpen(false)}
            >
              Register
            </Link> */}
          </div>
        </div>
      </nav>

      {/* spacing so content doesn't hide under navbar */}
      <div className="h-[72px]" />

      {/* -------------------------------------------------------------
                      ROLE SELECTION MODAL
      --------------------------------------------------------------- */}
      {roleModal && (
        <>
          {/* Background overlay */}
          <div
            className="fixed inset-0 bg-black/40 backdrop-blur-sm z-50"
            onClick={() => setRoleModal(false)}
          />

          {/* Modal box */}
          <div className="fixed inset-0 z-50 flex items-center justify-center px-4">
            <div
              className="bg-white rounded-xl shadow-xl p-6 w-full max-w-md border border-gray-200 animate-fadeIn"
              style={{ fontFamily: "Poppins, Roboto, sans-serif" }}
            >
              <h2 className="text-lg font-semibold text-gray-900 mb-1">
                Select Your Role
              </h2>
              <p className="text-sm text-gray-500 mb-5">
                Choose how you want to log in to the HRMS portal.
              </p>

              <div className="flex flex-col space-y-3">
                <Link
                  to="/login?role=employee"
                  className="w-full py-2.5 rounded-md bg-gray-900 text-white text-center font-medium hover:bg-black transition"
                  onClick={() => setRoleModal(false)}
                >
                  Employee Login
                </Link>

                <Link
                  to="/login?role=hr-admin"
                  className="w-full py-2.5 rounded-md border border-gray-800 text-gray-800 text-center font-medium hover:bg-gray-100 transition"
                  onClick={() => setRoleModal(false)}
                >
                  Admin Login
                </Link>
              </div>

              <button
                onClick={() => setRoleModal(false)}
                className="mt-4 text-sm text-gray-600 hover:text-gray-800 w-full text-center"
              >
                Cancel
              </button>
            </div>
          </div>
        </>
      )}

      {/* Fade-in animation */}
      <style>{`
        @keyframes fadeIn {
          from { opacity: 0; transform: translateY(10px); }
          to { opacity: 1; transform: translateY(0); }
        }
        .animate-fadeIn {
          animation: fadeIn 0.25s ease-out;
        }
      `}</style>
    </>
  );
}
